module.exports = __webpack_public_path__ + "img/shoulder_width.91295815.png";